import type {IntlShape} from 'react-intl'
import {tenantCurrencyCode, tenantCurrencySymbol} from '../../tenant/tenantState'

/**
 * The label to render next to an amount. A missing code means the store's own currency: amounts reach
 * the portal in the currency the store records them in, and most responses don't name it. JOD keeps the
 * translated `JD` label ("JOD" / "د.أ"); any other code prints the symbol the store's config gives it
 * (₪ for Felo's ILS), else the code itself.
 */
export function currencyLabel(code: string | null | undefined, formatMessage: IntlShape['formatMessage']): string {
  const c = (String(code ?? '').trim() || tenantCurrencyCode()).toUpperCase()
  if (c === 'JOD') return formatMessage({id: 'JD'})
  return tenantCurrencySymbol(c) || c
}

/** The label for an amount the API sends without a currency: the store's own. */
export function storeCurrencyLabel(formatMessage: IntlShape['formatMessage']): string {
  return currencyLabel(null, formatMessage)
}
